import React from 'react';
import { Hero } from '../components/home/Hero';
import { Problem } from '../components/home/Problem';
import { WhatToBuild } from '../components/home/WhatToBuild';
import { Applications } from '../components/home/Applications';
import { OriginInAction } from '../components/home/OriginInAction';
import { HowWeBuild } from '../components/home/HowWeBuild';
import { Voice } from '../components/home/Voice';
import { Pricing } from '../components/home/Pricing';
import { FAQ } from '../components/home/FAQ';
import { FinalCTA } from '../components/home/FinalCTA';
export function Home() {
  return <div className="w-full" data-id="element-323" data-mp="29gdekoa2geck">
      <Hero data-id="element-324" data-mp="29fc009tud9q3" />
      <Problem data-id="element-325" data-mp="29ek57182jg0v" />
      <WhatToBuild data-id="element-326" data-mp="29i7xxy5ovyej" />
      <Applications data-id="element-327" data-mp="2dhqk0x98yfiy" />
      <OriginInAction data-id="element-328" data-mp="2di8eppg9glor" />
      <HowWeBuild data-id="element-329" data-mp="2dii4bbxe8qtx" />
      <Voice data-id="element-330" data-mp="2dj1nsx2ozna2" />
      <Pricing data-id="element-331" data-mp="2dfdr5p1yakr4" />
      <FAQ data-id="element-332" data-mp="3kvabslgem9v0" />
      <FinalCTA data-id="element-333" data-mp="3kvtkrco2tnww" />
    </div>;
}